import React from "react";
import tokenHeaderStyles from "./scss/tokenHeader.module.scss";
import TokenBrand from "./TokenBrand";
import TokenDetails from "./TokenDetails";

const TokenHeader = ({ children, brand }) => {
  return (
    <div className={tokenHeaderStyles.topHeader}>
      <div className="row align-items-center">
        <TokenBrand brand={brand} />
        {children}
        {/* <TokenDetails /> */}
      </div>
    </div>
  );
};

export default TokenHeader;
